import * as React from "react";

function ButtonAlternateLoading(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 3.5C8.32843 3.5 9 2.82843 9 2C9 1.17157 8.32843 0.5 7.5 0.5C6.67157 0.5 6 1.17157 6 2C6 2.82843 6.67157 3.5 7.5 3.5Z"
      fill="#0059CC"
    />
    <path
      d="M7.5 15.5C8.32843 15.5 9 14.8284 9 14C9 13.1716 8.32843 12.5 7.5 12.5C6.67157 12.5 6 13.1716 6 14C6 14.8284 6.67157 15.5 7.5 15.5Z"
      fill="#0059CC"
    />
    <path
      d="M12.8032 4.81797C12.2174 5.40375 11.2677 5.40375 10.6819 4.81797C10.0961 4.23218 10.0961 3.28243 10.6819 2.69665C11.2677 2.11086 12.2174 2.11086 12.8032 2.69665C13.389 3.28243 13.389 4.23218 12.8032 4.81797Z"
      fill="#0059CC"
    />
    <path
      d="M2.19679 13.3034C2.78257 13.8892 3.73232 13.8892 4.31811 13.3034C4.90389 12.7177 4.90389 11.7679 4.31811 11.1821C3.73232 10.5963 2.78257 10.5963 2.19679 11.1821C1.611 11.7679 1.611 12.7177 2.19679 13.3034Z"
      fill="#0059CC"
    />
    <path
      d="M1.5 6.5C2.32843 6.5 3 7.17157 3 8C3 8.82843 2.32843 9.5 1.5 9.5C0.671573 9.5 0 8.82843 0 8C0 7.17157 0.671573 6.5 1.5 6.5Z"
      fill="#0059CC"
    />
    <path
      d="M15 8C15 7.17157 14.3284 6.5 13.5 6.5C12.6716 6.5 12 7.17157 12 8C12 8.82843 12.6716 9.5 13.5 9.5C14.3284 9.5 15 8.82843 15 8Z"
      fill="#0059CC"
    />
    <path
      d="M4.31815 2.69679C4.90394 3.28257 4.90394 4.23232 4.31815 4.81811C3.73236 5.40389 2.78262 5.40389 2.19683 4.81811C1.61104 4.23232 1.61104 3.28257 2.19683 2.69679C2.78262 2.111 3.73236 2.111 4.31815 2.69679Z"
      fill="#0059CC"
    />
    <path
      d="M12.8034 13.3032C13.3892 12.7174 13.3892 11.7677 12.8034 11.1819C12.2177 10.5961 11.2679 10.5961 10.6821 11.1819C10.0963 11.7677 10.0963 12.7174 10.6821 13.3032C11.2679 13.889 12.2177 13.889 12.8034 13.3032Z"
      fill="#0059CC"
    />
  </svg>
  );
}

export default ButtonAlternateLoading;